import React from 'react';
import WithNavigation from '../../layouts/WithNavigation';
import InboxDashboard from '../../components/Inbox/InboxDashboard';

const InboxContainer = () => {
    return (
        <WithNavigation
        title="Inbox"
        hide={true}
        border
         top={(
           <InboxDashboard
           image={(
             <img
               alt="No properties yet"
               src="/assets/empty/service-requests.svg"
             />
           )}
         />
         )}
        />
    )
}

export default InboxContainer;
